import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

function Input({ className, type, ...props }: ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "peer/input border-input placeholder:text-muted-foreground h-10 w-full min-w-0 rounded-none border bg-transparent px-3 py-2 text-base transition-colors outline-none",
        "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
        "disabled:bg-input/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "file:text-foreground file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium aria-invalid:ring-3",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
